import countryCallingCodes from 'country-calling-code';
import emojiFlags from 'emoji-flags';

export const getDropdownCountryOptions = () => {
    const pinned = ["972", "966", "970"]; // Israel, Saudi, Palestine
    const seen = new Set();
    const options = [];

    for (const entry of countryCallingCodes) {
        const country = entry.country;
        const isoCode = entry.isoCode2;
        const codes = entry.countryCodes;

        if (!country || !isoCode || !Array.isArray(codes) || !codes.length) continue;

        const dialCode = codes[0];
        const lowerIso = isoCode.toLowerCase();
        const flagUrl = `https://flagcdn.com/w40/${lowerIso}.png`;
        const key = `${dialCode}-${isoCode}`;

        if (seen.has(key)) continue;
        seen.add(key);

        options.push({
            value: dialCode,
            flagUrl,
            label: `+${dialCode} (${country})`,
            isPinned: pinned.includes(dialCode),
            shortLabel: `+${dialCode}`,
        });
    }

    // Sort with pinned first, then alphabetically
    return options.sort((a, b) => {
        if (a.isPinned && !b.isPinned) return -1;
        if (!a.isPinned && b.isPinned) return 1;
        return a.label.localeCompare(b.label);
    });
};
